import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { AssignableUserProfile } from '../../../domains/userManagement/types';

const ENDPOINT = `${APIConfiguration.authorization}users/upsertUserProfile`;

export interface UpsertUserProfileCommandArgs {
  userProfileId: string;
  name: string;
  tenantId?: string;
  roleIds: string[];
  cumulDashboardIds: string[];
  permissions: string[];
}

export const upsertUserProfileRequest = (
  payload: UpsertUserProfileCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

export const upsertUserProfileCommand = async (
  payload: UpsertUserProfileCommandArgs,
): Promise<BackResponse<AssignableUserProfile> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<AssignableUserProfile>>(
      upsertUserProfileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
